import { ReactNode } from 'react';
import { useLocalStorage } from '../../../shared/utils/useLocalStorage';
import classes from './Frame.module.scss';
import { NbHeader } from './Header';
import { Menu2 } from './Menu2';

export interface NbFrameProps {
  children: ReactNode;
}

export const Frame = ({ children }: NbFrameProps) => {
  const { isMenuCollapsed, setIsMenuCollapsed } = useLocalStorage();

  const toggleMenuCollapse = () => {
    setIsMenuCollapsed(!isMenuCollapsed);
  };

  return (
    <div className={`${classes.frame}`}>
      <NbHeader isMenuCollapsed={isMenuCollapsed} />
      <Menu2
        isMenuCollapsed={isMenuCollapsed}
        toggleMenuCollapse={toggleMenuCollapse}
      />
      <div className={`${classes.frameMain} ${isMenuCollapsed ? classes.frameMainIsCollapsed : ''}`}>{children}</div>
    </div>
  );
};
